import { useMutation } from '@apollo/client/react';
import { RECORD_INSTORE_ORDER } from 'api/graphql/inventory';
import { GET_VENDOR_CATALOG } from 'api/graphql/catalog';
import { useVendor } from 'features/vendor';

/**
 * Records an in-store sale, then refreshes the catalog so stock quantities
 * reflect the sale.
 *
 * Returns `recordSale({ items, customerPhone, notes, clientRequestId })`
 * resolving to the mutation payload. `vendorId` is injected from context;
 * `items` are `{ vendorCatalogId, quantity }` (price is applied server-side).
 */
export function useRecordInstoreSale() {
  const { vendorId } = useVendor();

  const [mutate, { loading }] = useMutation(RECORD_INSTORE_ORDER, {
    refetchQueries: vendorId ? [{ query: GET_VENDOR_CATALOG, variables: { vendorId } }] : [],
    awaitRefetchQueries: true,
  });

  const recordSale = async ({ items, customerPhone, notes, clientRequestId }) => {
    const input = {
      vendorId,
      items,
      ...(customerPhone ? { customerPhone } : {}),
      ...(notes ? { notes } : {}),
      ...(clientRequestId ? { clientRequestId } : {}),
    };
    const { data } = await mutate({ variables: { input } });
    return data?.recordInstoreOrder ?? null;
  };

  return { recordSale, loading };
}
